var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"super-discount-sticky-container"},[_c('separator',{staticClass:"separator"}),_vm._v(" "),_c('div',{staticClass:"padding-m"},[_vm._t("content"),_vm._v(" "),_c('riseup-button',{staticClass:"margin-top-m",attrs:{"action":function () { return this$1.$emit('click'); },"title":_vm.buttonText,"disabled":_vm.disabled}})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }